/* eslint-disable react/no-danger */
import React, { useRef, useEffect } from 'react';

function Item({ item, number }) {
  const domRef = useRef();

  function addSpaceNumber(num) {
    const characters = parseInt(num, 10).toString();
    let output;
    let offset;
    for (offset = characters.length; offset > 0; offset -= 3) {
      output = characters.slice(Math.max(offset - 3, 0), offset) + (output ? ' ' + output : '');
    }
    return output;
  }

  // Activate animated numbers when detected in viewport
  useEffect(() => {


    const observer = new IntersectionObserver((entries, observer) => {
      entries.forEach(entry => {
        if (entry.isIntersecting) {
          const counters = document.querySelectorAll('.value');
          const speed = 700;

          counters.forEach((counter) => {
            const animate = () => {
              const value = +counter.getAttribute('value');
              const data = +counter.innerText;
              const time = value / speed;
              if (data < value) {
                counter.innerText = Math.ceil(data + time);
                setTimeout(animate, 1);
              } else {
                counter.innerText = addSpaceNumber(value);
              }
            };

            animate();
          });
          observer.unobserve(domRef.current);
        }
      });
    }, { rootMargin: "0px 0px 200px 0px" });
    observer.observe(domRef.current);
  }, []);

  return (
    <div ref={domRef}>
      <h3 className="text-center">+<span className="value" value={number}>0</span></h3>
      <div
        className="item"
        dangerouslySetInnerHTML={{
          __html: item
        }}
      />
    </div>
  );
}

export default function SectionC(props) {
  const { content } = props;

  return (
    <section className="section-c">
      {content &&
      <div className="container">
        <div className="row">
          <div className="col-12 col-md-4">
            <Item item={content.numbers_text_1} number={content.number_item_1} />
          </div>
          <div className="col-12 col-md-4">
            <Item item={content.numbers_text_2} number={content.number_item_2} />
          </div>
          <div className="col-12 col-md-4">
            <Item item={content.numbers_text_3} number={content.number_item_3} />
          </div>
        </div>
      </div>}
    </section>
  );
}
